import Layout from 'features/shared/Layout';

import { BecomeAPartner } from '@frontendmentorio/design-system-v2';

export default function Page() {
  return (
    <Layout
      description="Support developers in building hands-on coding skills and earn a 30% recurring commission as a Frontend Mentor Partner"
      image="https://res.cloudinary.com/dz209s6jk/image/upload/v1585172856/Meta/meta-homepage.png"
      title="Frontend Mentor | Join the Frontend Mentor Partner Program"
      url="https://www.frontendmentor.io/become-a-partner"
    >
      <BecomeAPartner />
    </Layout>
  );
}

export async function getStaticProps() {
  return { props: {} };
}
